import { render, staticRenderFns } from "./ChallengesView.vue?vue&type=template&id=37a021fc&scoped=true&"
import script from "./ChallengesView.vue?vue&type=script&lang=js&"
export * from "./ChallengesView.vue?vue&type=script&lang=js&"
import style0 from "./ChallengesView.vue?vue&type=style&index=0&id=37a021fc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a021fc",
  null
  
)

export default component.exports